var map = {
	"./Act2/Structure/BlockList.js": 48842,
	"./Act2/Structure/BlockQuote.js": 68627,
	"./Act2/Structure/BodyCopy.js": 3304,
	"./Act2/Structure/LeadParagraph.js": 28461,
	"./Act2/Structure/Title.js": 64081,
	"./Structure/AlignedQuote.js": 36555,
	"./Structure/BodyCopy.js": 44474,
	"./Structure/BreakoutQuote.js": 8693,
	"./Structure/CenteredQuote.js": 90835,
	"./Structure/LeadParagraph.js": 24894,
	"./Structure/MegaQuote.js": 57713,
	"./Structure/PicketTitle.js": 58704,
	"./Structure/SectionTitle.js": 80706,
	"./Structure/WideCenteredQuote.js": 53138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95148;